import React from 'react';
import './Hero.css';
import Header from '../Header/Header';
import hero_image from "../../assets/hero_image.png";
import hero_image_back from "../../assets/hero_image_back.png";
import Heart from "../../assets/heart.png";
import Calories from "../../assets/calories.png";
import {motion} from 'framer-motion';
import NumberCounter from 'number-counter';
import { Link } from "react-scroll/modules";

const Hero=()=>{
    const transition={type: 'tween', duration: 3};
    const mobile=window.innerWidth<=768?true:false;
    return (
        <div className="hero" id="Hero">
            <div className="blur hero-blur"></div>
            <div className='hero-left'> 
                <Header/>
                {/* The best ad */}
                <div className='the-best-ad'>
                    <motion.div 
                    initial={{left: mobile?'185px':'238px'}}
                    whileInView={{left: '6px'}}
                    transition={transition}
                    ></motion.div>
                    <span>the best fitness club in the world</span>
                </div>
                {/* Hero Heading */}
                <div className='hero-text'>
                    <div>
                        <span className='stroke-text'>Shape </span>
                        <span>Your</span>
                    </div>
                    <div><span>Ideal Body</span></div>
                    <div><span>In here we will help you to shape and build your ideal body and live up your life to fullest</span></div>
                </div>
                {/* experiance figures */}
                <div className="figures">
                    <div><span><NumberCounter preFix="+" start={100} end={140} delay="4" /></span><span>expert coachs</span></div>
                    <div><span><NumberCounter preFix="+" start={0} end={50} delay="1" /></span><span>fitness programs</span></div>
                    <div><span><NumberCounter preFix="+" start={700} end={978} delay="4" /></span><span>members joined</span></div>
                </div>
                {/* Hero buttons */}
                <div className="hero-buttons">
                    <Link to="Join" spy={true} smooth={true}>
                            <button className="btn">Get Started</button>
                    </Link>
                    <Link to="Plans" spy={true} smooth={true}>
                        <button className="btn">Learn More</button>
                    </Link>
                </div>
            </div>
            <div className='hero-right'>
                <Link to="Join" spy={true} smooth={true}>
                    <button className="btn">Join Now</button>
                </Link>
                <motion.div 
                initial={{right: '-1rem'}}
                whileInView={{right: '3rem'}}
                transition={transition}
                className="heart-rate">
                    <img src={Heart} alt="" />
                    <span>Heart Rate</span>
                    <span>116 BPM</span>
                </motion.div>
                {/* Hero images */}
                <img src={hero_image} alt="" className='hero-image' />
                <motion.img
                initial={{right: '1rem'}}
                whileInView={{right: '20rem'}}
                transition={transition}
                src={hero_image_back} alt="" className='hero-image-back' />
                {/* Calories */}
                <motion.div 
                initial={{right: '37rem'}}
                whileInView={{right: '28rem'}}
                transition={transition}
                className="calories">
                    <img src={Calories} alt="" />
                    <div>
                        <span>Calories Burned</span>
                        <span>220 kcal</span>
                    </div>                    
                </motion.div>
            </div>
            <div className="space-right"></div>
        </div>
    )
}

export default Hero;